export default __webpack_public_path__ + "static/media/background4.355a3912.png";